import React, {Component} from 'react';
import { connect} from 'react-redux'
import {bindActionCreators, compose} from 'redux'
import CTable from '@/components/CTable'
import CButton from '@/components/CButton'
import CBaseComponent from '@/components/CBaseComponent'
import { setReload } from "@/redux/common/action";
import { tableData, tableData1, tableData2, tableData3} from './data'
import './index.scss'
import { getPftjHandler } from "@/servers/goodsManageApi";
import {withRouter} from "react-router-dom";
import { Radio } from 'antd';


@CBaseComponent
class GoodsManageList extends Component{
  constructor(props) {
    super(props);
    this.getListData = this.getListData.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.getListData();
  }


  state = {
    columns: tableData.tHead,
    columns1: tableData1.tHead,
    columns2: tableData2.tHead,
    columns3: tableData3.tHead,
    dataSource: tableData.tBody,
    dataSource1: tableData1.tBody,
    dataSource2: tableData2.tBody,
    dataSource3: tableData3.tBody,
    loading: true,
  };

  // 获取用户列表数据
  getListData(){
    this.setState({
      loading: true
    });
    getPftjHandler().then(res=>{
      let data =JSON.parse(JSON.stringify(res.records))
      this.setState({
        dataSource: data,
        loading: false
      });
    }).catch(err=>{
      console.log(err,'rttt')
    })
  }

  componentWillMount(){

  }

  componentDidMount(){
    this.getListData();
  }
  render(){
    return (
        <div className='user-manage-list'>
            {this.state.dataSource.map((item,index)=>{
                return(
                    <div>
                        {index === 0?
                            <h2>{item.title}</h2>:
                            <h2 style={{marginTop:'50px'}}>{item.title}</h2>
                        }
                        {
                            item.datalist.map((item,index1)=>{
                                return (<div style={{display:'flex',borderBottom:'1px solid #bebebe',marginTop:'20px'}}>
                                    {
                                        item.map(item2=>{
                                            return (
                                                <div style={{flex:1,textAlign:'center',marginBottom:'10px',alignItems:'center'}}>{item2}</div>
                                            )
                                        })
                                    }
                                </div>)
                            })
                        }
                    </div>
                )
            })}
        </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    reload: state.reload,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    setReload: bindActionCreators(setReload, dispatch)
  }
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(GoodsManageList);
